module.exports = __webpack_public_path__ + "img/banner-tc3.d7ccdd46.jpg";